// extracted by mini-css-extract-plugin
export default {"cardLabel":"card-label-module__cardLabel--W72DU","tooltip":"card-label-module__tooltip--Oqsk8","ReviewersToken":"card-label-module__ReviewersToken--iujMK"};